import { getApiHost } from 'api/host-by-env';
import { OracleDowntimeSchedule } from 'features/OracleDowntimeSchedule/types';
import { handleBusinessError, handleError } from 'utilities/utilities';

const BASE_URL = `${getApiHost()}order-management/oracle-downtime`;

export interface OracleDowntimeType {
  TypeCdId: number;
  Description: string;
}

export interface CreateOracleDowntimeScheduleRequest {
  StartDateTime: string;
  EndDateTime?: string | null;
  DowntimeTypeCdId: number;
}

export interface UpdateOracleDowntimeScheduleRequest {
  OracleDowntimeScheduleId: number;
  StartDateTime: string;
  EndDateTime?: string | null;
  DowntimeTypeCdId: number;
  UpdTS: string;
}

export interface DeleteOracleDowntimeScheduleRequest {
  OracleDowntimeScheduleId: number;
}

export async function getOracleDowntimeSchedules(token: string): Promise<OracleDowntimeSchedule[]> {
  const response = await fetch(BASE_URL, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const json = await response.json();
  handleError(json);
  handleBusinessError(json);
  return json.result || [];
}

export async function getOracleDowntimeTypes(token: string): Promise<OracleDowntimeType[]> {
  const response = await fetch(`${BASE_URL}/types`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const json = await response.json();
  handleError(json);
  handleBusinessError(json);
  return json.result || [];
}

export async function createOracleDowntimeSchedule(
  payload: CreateOracleDowntimeScheduleRequest,
  token: string,
): Promise<OracleDowntimeSchedule> {
  const response = await fetch(BASE_URL, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const json = await response.json();
  handleError(json);
  handleBusinessError(json);
  return json.result;
}

export async function updateOracleDowntimeSchedule(
  payload: UpdateOracleDowntimeScheduleRequest,
  token: string,
): Promise<OracleDowntimeSchedule> {
  const response = await fetch(BASE_URL, {
    method: 'PUT',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const json = await response.json();
  handleError(json);
  handleBusinessError(json);
  return json.result;
}

export async function deleteOracleDowntimeSchedule(
  payload: DeleteOracleDowntimeScheduleRequest,
  token: string,
): Promise<boolean> {
  const response = await fetch(BASE_URL, {
    method: 'DELETE',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const json = await response.json();
  handleError(json);
  handleBusinessError(json);
  return json.result;
}
